// extracted by mini-css-extract-plugin
export default {"label":"hNKDbkarpv","controlWrapper":"dhMN0_ILbo","control":"dTt8eyzliF","chevron":"fjZAwJpwZt","dark":"gleegnekye"};